import React from "react";
import PropTypes from "prop-types";
// @material-ui/core components
import Button from "components/CustomButtons/Button.js";
import GridItem from "components/Grid/GridItem.js";
import GridContainer from "components/Grid/GridContainer.js";
import { makeStyles } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
// core components
import styles from "assets/jss/material-dashboard-react/components/tableStyle.js";
import Loader from "components/Loader/Loader";
import { Domain } from "Domain";

const useStyles = makeStyles(styles);

export default function CustomTable1({
  tableHead,
  tableData,
  setEdit,
  loading,
  noAction,
  Images,
}) {
  const classes = useStyles();
  return (
    <div className={classes.tableResponsive}>
      {loading ? (
        <GridContainer justify="center">
          <GridItem xs={12} sm={12} md={1}>
            <Loader />
          </GridItem>
        </GridContainer>
      ) : (
        <Table className={classes.table}>
          {tableHead !== undefined ? (
            <TableHead>
              <TableRow className={classes.tableHeadRow}>
                {tableHead.map((prop, key) => {
                  return (
                    <TableCell
                      style={{ borderBottom: "3px solid #9f5c16" }}
                      className={
                        classes.tableCell + " " + classes.tableHeadCell
                      }
                      key={key}
                    >
                      <b>{prop}</b>
                    </TableCell>
                  );
                })}
              </TableRow>
            </TableHead>
          ) : null}

          <TableBody>
            {tableData.map((prop, key) => {
              return (
                <TableRow key={key} className={classes.tableBodyRow}>
                  {Images ? (
                    <>
                      {prop.Image && (
                        <img
                          className={classes.tableCellImage}
                          src={Domain + prop.Image}
                          alt=".."
                        />
                      )}
                    </>
                  ) : (
                    <></>
                  )}
                  {Object.values(prop).map((props, key) => {
                    return (
                      <TableCell
                        style={{ borderBottom: "1.5px solid #9f5c16" }}
                        className={classes.tableCell}
                        key={key}
                      >
                        <span style={{ fontSize: 19 }}>{props} </span>
                      </TableCell>
                    );
                  })}
                  {noAction ? (
                    <></>
                  ) : (
                    <>
                      {" "}
                      <Button
                        onClick={() => setEdit(prop.Name)}
                        color="success"
                      >
                        Open
                      </Button>
                    </>
                  )}
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      )}
    </div>
  );
}

CustomTable1.defaultProps = {
  tableHeaderColor: "gray",
};

CustomTable1.propTypes = {
  tableHeaderColor: PropTypes.oneOf([
    "warning",
    "primary",
    "danger",
    "success",
    "info",
    "rose",
    "gray",
  ]),
  tableHead: PropTypes.arrayOf(PropTypes.string),
  tableData: PropTypes.arrayOf(PropTypes.arrayOf(PropTypes.string)),
  setEdit: PropTypes.any,
  setDelete: PropTypes.any,
  loading: PropTypes.bool,
  noAction: PropTypes.bool,
  Images: PropTypes.bool,
};
